
export class AudanetOperationType {

     static ImportStandardCostEstimation  = 1;
     static UpdateStandardCostEstimation  = 2;
     static ImportAdditionalCostEstimation  = 3;
     static UpdateAdditionalCostEstimation  = 4;
     static UpdateAceptedDataOfCostEstimation  = 5;
     static SelectionOfAudanetTask  = 6;
    }